import React, { useEffect, useState } from "react";
import AssessmentDataService from "../../services/Assessment";
import { MonthlyBarChart } from "../../components/Chart/MonthlyBarChart";
import { DateRangeBarChart } from "../../components/Chart/DateRangeBarChart";
import { Flex, Select, useDisclosure } from "@chakra-ui/react";
import { new_lead_status } from "../../Config/leadStatus";
import DateRangeModal from "../../components/Modals/DateRangeModal";

export const AssessementRecords = () => {
  const token = localStorage.getItem("logged_in_user_token");
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [viewMode, setViewMode] = useState("currentWeek");
  const [leadStatus, setLeadStatus] = useState("");

  const [assessmentCountData, setAssessmentCountData] = useState<any>([]);

  const [modal, setModal] = useState("");

  const getDateFormat = (dateString: string) => {
    let date = new Date(dateString);
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();
    let monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    let monthName = monthNames[monthIndex];
    let newDateString = day + "-" + monthName + "-" + year;
    return newDateString;
  };

  const calculateTotalSum = (arr: any[]) => {
    // const modifiedArray = n > 0 ? arr.slice(0, -n) : arr;

    const totalSum = arr.reduce((sum, obj) => {
      const expertTotal =
        (obj.Prakriti || 0) + (obj.Jigyasa || 0) + (obj.Tania || 0);
      return sum + expertTotal;
    }, 0);

    return totalSum;
  };

  const calculateSum = (arr: any[], expertKey: string) => {
    const totalSum = arr.reduce((sum, obj) => {
      const expertTotal = obj[expertKey] || 0;
      return sum + expertTotal;
    }, 0);

    return totalSum;
  };

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const fetchAssessmentCountByExpertData = async(
    startDate: string,
    endDate: string
  ) => {
    let start = "";
    let end = "";

    const today = new Date();

    if (viewMode === "currentMonth") {
      const first = new Date(today.getFullYear(), today.getMonth(), 1);
      const last = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      start = first.toISOString().slice(0, 10); // YYYY-MM-DD
      end = last.toISOString().slice(0, 10);
    } else if (viewMode === "lastMonth") {
      const first = new Date(today.getFullYear(), today.getMonth() - 1, 1);
      const last = new Date(today.getFullYear(), today.getMonth(), 0);
      start = first.toISOString().slice(0, 10);
      end = last.toISOString().slice(0, 10);
    } else if (viewMode === "currentWeek") {
      const dayOfWeek = today.getDay(); // 0 (Sun) - 6 (Sat)
      const diffToMonday =
        today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
      const monday = new Date(today.setDate(diffToMonday));
      const sunday = new Date(monday);
      sunday.setDate(monday.getDate() + 6);

      start = monday.toISOString().slice(0, 10);
      end = sunday.toISOString().slice(0, 10);
    } else {
      // custom date range
      start = startDate;
      end = endDate;
    }

    setStartDate(start);
    setEndDate(end);

    AssessmentDataService.getCountByExpertData(
      token,
      start,
      end,
      leadStatus
    )
      .then((res: any) => {
        const data = res.data.map((item: any) => {
          return {
            date: getDateFormat(item.date),
            Prakriti: item.expert_prakriti,
            Jigyasa: item.expert_jigyasa,
            Mahi: item.expert_mahi,
            Navya: item.expert_navyav,
            Tania: item.expert_tania,
          };
        });
        setAssessmentCountData(data);
      })
      .catch((e: any) => {
        console.log(e);
      });
  };

  useEffect(() => {
    fetchAssessmentCountByExpertData(startDate, endDate);
  }, [viewMode, leadStatus]);

  return (
    <div className="main-wrapper">
      <div className="page_title py-2">Free Consultation - Admin Panel</div>
      <div className="p-4">
        <Flex gap={8}>
          <Select
            w="160px"
            placeholder="Select Type"
            value={viewMode}
            onChange={(e) => {
              setViewMode(e.target.value);
              if (e.target.value === "customDateRange") {
                setModal("dateRangeModal");
                onOpen();
              }
            }}
          >
            <option value="currentMonth">Current Month</option>
            <option value="lastMonth">Last Month</option>
            <option value="currentWeek">Current Week</option>
            <option value="customDateRange">Custom</option>
          </Select>

          {modal === "dateRangeModal" && (
            <DateRangeModal
              isOpen={isOpen}
              onClose={onClose}
              startDate={startDate}
              endDate={endDate}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              func={fetchAssessmentCountByExpertData}
            />
          )}
          <Select
            id="lead_status"
            w="200px"
            value={leadStatus}
            onChange={(e) => {
              setLeadStatus(e.target.value);
            }}
          >
            {/* <option value="">Please select</option> */}
            {new_lead_status.map((el) => (
              <option key={el.data} value={el.value}>
                {el.data}
              </option>
            ))}
          </Select>
        </Flex>

        <div className="notification-header d-flex justify-content-between align-items-center mb-5">
          <div className="notifications-title">
            {viewMode === "currentMonth"
              ? "Current Month Report"
              : viewMode === "lastMonth"
              ? "Last Month Report"
              : viewMode === "currentWeek"
              ? "Current Week Report"
              : "Custom Report"}
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="text-center col-sm-12">
            {assessmentCountData && (
              <div className="chart-container">
                {" "}
                <DateRangeBarChart data={assessmentCountData} />
              </div>
            )}
          </div>
          <div className="ehc-records">
            <div>
              {`Total Free Consultation Scheduled : ${calculateTotalSum(
                assessmentCountData
              )}`}
            </div>
            {["Prakriti", "Jigyasa", "Tania"].map((expert) => (
              <div key={expert}>
                {`Free Consultation Scheduled for ${expert}: ${calculateSum(
                  assessmentCountData,
                  expert
                )}`}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
